import React, { useEffect, useRef, useState } from "react";
import { useZoAuthenticatedApi } from "../../../../../hooks/useApi";

interface CountrySelectorProps {
  country: string;
  setCountry: (country: string) => void;
  className?: string;
  placeholder?: string;
}

interface Country {
  name: string;
  code: string;
  local_currency: string;
  flag: string;
  mobile_code: string;
}

const CountrySelector: React.FC<CountrySelectorProps> = ({
  country,
  setCountry,
  className = "",
  placeholder = "Country",
}) => {
  const locationsApi = useZoAuthenticatedApi("ZOWORLD_COUNTRIES");
  const [countries, setCountries] = useState<Country[]>([]);
  const [filteredCountries, setFilteredCountries] = useState<Country[]>([]);
  const [isActive, setIsActive] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const searchInputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (locationsApi) {
      locationsApi
        .get("")
        .then((res) => {
          console.log(res, "res");
          setCountries(res.data.results);
          setFilteredCountries(res.data.results);
        })
        .catch((e) => {
          console.error("Error fetching countries:", e);
        });
    }
  }, [locationsApi]);

  console.log(countries);

  useEffect(() => {
    setIsActive(!!country);
  }, [country]);

  useEffect(() => {
    if (searchTerm) {
      const filtered = countries.filter((country) =>
        country.name.toLowerCase().includes(searchTerm.toLowerCase())
      );
      setFilteredCountries(filtered);
    } else {
      setFilteredCountries(countries);
    }
  }, [searchTerm, countries]);

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchTerm(e.target.value);
  };

  const handleSelectCountry = (countryId: string) => {
    setCountry(countryId);
    setIsDropdownOpen(false);
  };

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
    if (searchInputRef.current) {
      searchInputRef.current.focus();
    }
  };

  const selectedCountryName = country
    ? countries.find((c) => c.code === country)?.name
    : "";

  return (
    <div className="w-full h-14">
      <div className="relative border rounded-lg h-full">
        <label
          className={`absolute transition-all  duration-300 ease-out ${
            isActive
              ? "text-xs mt-1 ml-3 text-secondary"
              : "text-base mt-3 ml-3 text-primary"
          }`}
        >
          {placeholder}
        </label>
        <div
          className={`flex items-center justify-between pt-2 w-full h-full px-3 cursor-pointer ${className}`}
          onClick={toggleDropdown}
        >
          {selectedCountryName || ""}
        </div>
        {isDropdownOpen && (
          <div
            className="absolute z-10 w-full mt-1 bg-white border border-stroke-primary rounded-lg "
            style={{ maxHeight: 320, overflowY: "auto" }}
          >
            <div className="p-2">
              <input
                type="text"
                placeholder="Search countries..."
                value={searchTerm}
                onChange={handleSearchChange}
                className="flex-grow w-full p-2 focus:outline-none focus:shadow-outline rounded border"
                onClick={(e) => e.stopPropagation()}
                ref={searchInputRef}
                autoFocus
              />
            </div>
            <div className="max-h-60 overflow-y-auto">
              {filteredCountries.map((country: Country) => (
                <div
                  key={country.code}
                  className="p-2 hover:bg-gray-100 cursor-pointer"
                  onClick={() => handleSelectCountry(country.code)}
                >
                  {country.flag && `${country.flag} `}
                  {country.name}
                </div>
              ))}
              {filteredCountries.length === 0 && (
                <div className="p-2 text-gray-500">No countries found</div>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default CountrySelector;
